import { render, staticRenderFns } from "./FeedIcon.vue?vue&type=template&id=5b6eeeef"
import script from "./FeedIcon.vue?vue&type=script&lang=js"
export * from "./FeedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports